import React, { useState, useEffect, useRef } from "react";
import {
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Row,
    Col,
    Label
} from "reactstrap";
import ClearIcon from "@material-ui/icons/Delete";
import { setActivity } from "../../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";
import _ from "lodash";
import { connect } from "react-redux";
import {
    Button,
    Chip,
    Select,
    MenuItem,
    TextField,
    List,
    ListItem,
    ListItemText,
    Typography,
    Divider,
    IconButton,
} from "@material-ui/core";
import { Remove as RemoveIcon } from "@material-ui/icons";

import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import { selectAllEquipmentTypes } from "../selectors";
import { getEquipmentTypes } from "../actions";
import AddBoxIcon from "@material-ui/icons/AddBox";
import Avatar from "@material-ui/core/Avatar";
import styled from "styled-components";
import Snackbar from "@material-ui/core/Snackbar";

const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;

const AddEditModal = (props) => {
    const [isOpen, setModalState] = useState(props.isOpen);
    const [modalType, setModalType] = useState(props.type);
    const [qr, setQR] = useState(props.qr);
    const [areas, setAreas] = useState(props.areas);
    const [departments, setDepartments] = useState(props.departments);
    const [qrUID, setQRUID] = useState(props.qrUID);
    const [equ, setEquipmentTypes] = useState(props.equipmentTypes);
    const [profileImgBlob, setProfileImgBlob] = useState(false);
    const fileUploadRef = useRef();
    const UploadFileRef = useRef();
    const { setState } = props;
    const [snackbarState, setSnackbarState] = React.useState({
        open: false,
        vertical: "top",
        horizontal: "center",
    });
    const { vertical, horizontal, open } = snackbarState;
    const handleClose = () => {
        setSnackbarState({ ...snackbarState, open: false });
    };

    useEffect(() => {
        setModalState(props.isOpen);
        setModalType(props.type);
        setQR(props.qr);
        setQRUID(props.qrUID);
        setEquipmentTypes(props.equipmentTypes);
        setAreas(props.areas);
        setDepartments(props.departments);
    }, [
        props.isOpen,
        props.type,
        props.qr,
        props.qrUID,
        props.equipmentTypes,
        props.areas,
        props.departments,
    ]);

    return (
        <>
        <Modal isOpen={isOpen}>
            <ModalHeader>
                {modalType === "add" ? "Add" : "Edit"} Equipment
            </ModalHeader>
            <ModalBody>
                <ModalRow>
                    <Col>
                        <Chip
                            label="The are following characters are not allowed: '/', '\' or '|'"
                            style={{
                                width: "100%",
                                background: "red",
                                color: "white",
                            }}
                        />
                        <ModalRow>
                            <Col>
                                <br />
                                <IconButton
                                    mini
                                    aria-label="delete"
                                    onClick={() => {
                                        props.removeImage(qr.uid, (success) => {
                                            if (success === true) {
                                                setQR({
                                                    ...qr,
                                                    photo_url: "",
                                                });
                                                setProfileImgBlob("");
                                            }
                                        });
                                        //set the snackbar
                                        setSnackbarState({
                                            ...snackbarState,
                                            open: true,
                                        });
                                    }}
                                    style={{
                                        position: "absolute",
                                        top: 12,
                                        right: 165,
                                        background: "red",
                                        color: "white",
                                        height: 16,
                                        width: 16,
                                    }}
                                    size="small"
                                >
                                    <RemoveIcon fontSize="inherit" />
                                </IconButton>
                                <Avatar
                                    style={{
                                        width: 150,
                                        height: 150,
                                        marginLeft: 150,
                                        borderRadius: "12px",
                                        border: "2px solid #0188cc",
                                    }}
                                    src={
                                        qr.photo_url
                                            ? qr.photo_url
                                            : profileImgBlob
                                    }
                                    alt=""
                                />

                                <div
                                    style={{
                                        marginLeft: 0,
                                        position: "absolute",
                                        bottom: 0,
                                    }}
                                >
                                    <Typography variant="subtitle1">
                                        Add Image
                                    </Typography>
                                    <input
                                        type="file"
                                        id="file"
                                        ref={fileUploadRef}
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={(event) => {
                                            if (
                                                event.target.files[0].size >
                                                1000000
                                            ) {
                                                setState(
                                                    "fileMaxSizeSnackbar",
                                                    true
                                                );
                                            } else {
                                                setQR({
                                                    ...qr,
                                                    photo_url: URL.createObjectURL(
                                                        event.target.files[0]
                                                    ),
                                                });
                                                setProfileImgBlob(
                                                    event.target.files[0]
                                                );
                                            }
                                        }}
                                    />

                                    <AddBoxIcon
                                        color="#0188cc"
                                        onClick={() => {
                                            fileUploadRef.current.click();
                                        }}
                                        style={{
                                            margin: "inherit",
                                            color: "#0188cc",
                                            height: "50px",
                                            width: "50px",
                                        }}
                                    ></AddBoxIcon>
                                    <Typography
                                        style={{ margin: "inherit" }}
                                        variant="subtitle1"
                                    >
                                        {"(< 1MB)"}
                                    </Typography>
                                </div>
                            </Col>
                            <Snackbar
                                anchorOrigin={{ vertical, horizontal }}
                                open={open}
                                onClose={handleClose}
                                message="Profile Picture deleted successfully"
                                key={vertical + horizontal}
                                autoHideDuration={5000}
                            />
                        </ModalRow>
                        <Divider style={{ margin: 24 }} />
                        <ModalRow>
                            <Col>
                                <Label for="name">Name </Label>

                                <TextField
                                    style={{ width: "100%" }}
                                    id="name"
                                    sty
                                    value={qr.name}
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setQR({
                                                ...qr,
                                                name: event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                            <Col>
                                <Label for="category">Category</Label>
                                <Select
                                    id="category"
                                    value={qr.category}
                                    style={{ width: "100%" }}
                                    onChange={(event) => {
                                        setQR({
                                            ...qr,
                                            category: event.target.value,
                                        });
                                    }}
                                >
                                    {equ &&
                                        equ.map((equipmentTypes, key) => {
                                            return (
                                                <MenuItem
                                                    key={key}
                                                    value={equipmentTypes}
                                                >
                                                    {equipmentTypes}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="areas">Area's</Label>

                                <Select
                                    variant="outlined"
                                    id="areas"
                                    multiple
                                    style={{ width: "100%" }}
                                    value={qr.area || []}
                                    onChange={(event) => {
                                        setQR({
                                            ...qr,
                                            area: event.target.value,
                                        });
                                    }}
                                >
                                    {areas &&
                                        areas.map((e) => {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                            <Col>
                                <Label for="departments">Departments</Label>

                                <Select
                                    variant="outlined"
                                    id="departments"
                                    multiple
                                    style={{ width: "100%" }}
                                    value={qr.department || []}
                                    onChange={(event) => {
                                        setQR({
                                            ...qr,
                                            department: event.target.value,
                                        });
                                    }}
                                >
                                    {departments &&
                                        departments.map((e) => {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                        </ModalRow>
                        <Label for="status">Status</Label>

                        <Select
                            id="status"
                            value={qr.status}
                            style={{ width: "100%" }}
                            onChange={(event) => {
                                setQR({
                                    ...qr,
                                    status: event.target.value,
                                });
                            }}
                        >
                            <MenuItem value="Commissioning">
                                Commissioning
                            </MenuItem>
                            <MenuItem value="Needing Repair">
                                Needing Repair
                            </MenuItem>
                            <MenuItem value="Needing Service">
                                Needing Service
                            </MenuItem>
                            <MenuItem value="Do not use">Do Not Use</MenuItem>
                            <MenuItem value="Operational">Operational</MenuItem>
                            <MenuItem value="Decommissioned">
                                Decommissioned
                            </MenuItem>
                        </Select>
                    </Col>
                </ModalRow>
                <ModalRow>
                    <Col>
                        <Col>
                            <Label for="notes">Notes</Label>
                            <TextField
                                style={{ width: "100%" }}
                                id="notes"
                                value={qr.notes}
                                onChange={(event) => {
                                    setQR({
                                        ...qr,
                                        notes: event.target.value,
                                    });
                                }}
                            />
                        </Col>
                    </Col>
                </ModalRow>
                <ModalRow>
                    <Col>
                        <Label for="service_period">
                            Service Period(months)
                        </Label>
                        <TextField
                            style={{ width: "100%" }}
                            id="service_period"
                            value={qr.service_period}
                            onChange={(event) => {
                                setQR({
                                    ...qr,
                                    service_period: event.target.value,
                                });
                            }}
                        />
                    </Col>
                    <Col>
                        <Label for="dos">Date Of Last Service</Label>
                        <div>
                            <DayPickerInput
                                id="dos"
                                placeholder="DD-MM-YYYY"
                                value={qr.date_last_service}
                                format={"DD-MM-YYYY"}
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={(day) => {
                                    setQR({
                                        ...qr,
                                        date_last_service: moment(day).format(
                                            "DD-MM-YYYY"
                                        ),
                                    });
                                }}
                            />
                        </div>
                    </Col>
                </ModalRow>
                <ModalRow>
                    <Col>
                        <Label for="thorough_examination_period">
                            Thorough Examination Period(months)
                        </Label>
                        <TextField
                            style={{ width: "100%" }}
                            id="thorough_examination_period"
                            value={qr.thorough_examination_period}
                            onChange={(event) => {
                                setQR({
                                    ...qr,
                                    thorough_examination_period:
                                        event.target.value,
                                });
                            }}
                        />
                    </Col>
                </ModalRow>
                <ModalRow>
                    <Col>
                        <Label for="doe">Date Of Last Examination</Label>
                        <div>
                            <DayPickerInput
                                id="doe"
                                placeholder="DD-MM-YYYY"
                                value={qr.date_last_examination}
                                format={"DD-MM-YYYY"}
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={(day) => {
                                    setQR({
                                        ...qr,
                                        date_last_examination: moment(
                                            day
                                        ).format("DD-MM-YYYY"),
                                    });
                                }}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Label for="idd">Inspection Due Date</Label>
                        <div>
                            <DayPickerInput
                                id="idd"
                                placeholder="DD-MM-YYYY"
                                value={qr.inspection_due_date}
                                format={"DD-MM-YYYY"}
                                formatDate={formatDate}
                                parseDate={parseDate}
                                onDayChange={(day) => {
                                    setQR({
                                        ...qr,
                                        inspection_due_date: moment(
                                            day
                                        ).format("DD-MM-YYYY"),
                                    });
                                }}
                            />
                        </div>
                    </Col>
                </ModalRow>
                <Row>
                    <React.Fragment>
                        <input
                            accept="application/pdf"
                            type="file"
                            multiple
                            onChange={(event) => {
                                let attached_files =
                                    _.get(qr, "attached_files") || [];
                                Object.keys(event.target.files).map(
                                    async (file_index) => {
                                        if (
                                            event.target.files[file_index]
                                                .size < 10000000
                                        )
                                            await props.uploadFile(
                                                event.target.files[file_index],
                                                "equipment_documents",
                                                (status) => {},
                                                (newFile) => {
                                                    attached_files = [
                                                        ...attached_files,
                                                        newFile,
                                                    ];
                                                    setQR({
                                                        ...qr,
                                                        attached_files,
                                                    });
                                                }
                                            );
                                        else
                                            this.setState({
                                                maxSizeExceeded: true,
                                            });
                                        return true;
                                    }
                                );
                            }}
                            style={{
                                display: "none",
                            }}
                            ref={UploadFileRef}
                        />
                        <Button
                            fullWidth
                            style={{
                                width: "100%",
                                display: "inline",
                                backgroundColor: "#0188cc",
                                color: "white",
                            }}
                            onClick={() => {
                                UploadFileRef.current.click();
                            }}
                            variant="contained"
                        >
                            + Upload File
                        </Button>
                    </React.Fragment>
                </Row>
                <Row>
                    {/* {qr.attached_files && (
                        <List>
                            {qr.attached_files.map((e) => {
                                return (
                                    <ListItem>
                                        <ListItemText primary={e.file} />
                                    </ListItem>
                                );
                            })}
                        </List>
                    )} */}
                    {qr.attached_files && (
                        <List>
                            {qr.attached_files.map((e,i) => {
                                return (
                                    <ListItem>
                                        <ListItemText primary={e.file_name ? e.file_name : e.file } />
                                        {
                                            modalType !== "add" ? 
                                            <ClearIcon
                                                style={{ color: "red", width: "10%" }}
                                                onClick={() => {
                                                    let fileArray = []
                                                    qr.attached_files.splice(i, 1)
                                                    fileArray = qr.attached_files
                                                    setQR({
                                                        ...qr,
                                                        attached_files: fileArray,
                                                    });
                                            }}
                                            ></ClearIcon>
                                            :
                                            ""
                                        }
                                        
                                    </ListItem>
                                );
                            })}
                        </List>
                    )}
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => {
                        props.close();
                        setProfileImgBlob(false);
                    }}
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        props.setQR(qrUID, qr, profileImgBlob);
                        setProfileImgBlob(false);
                        props.setActivity(
                            modalType === "add" ? "create" : "update",
                            "equipment",
                            qr.name
                        );
                        props.close();
                    }}
                    variant="contained"
                    style={{
                        backgroundColor: "#0188cc",
                        color: "white",
                    }}
                >
                    Save Changes
                </Button>
            </ModalFooter>
        </Modal>
        {/* <Modal
        isOpen={props.requesting}
        style={{ maxWidth: "00px" }}
    >
        <ModalBody>
            <div
                style={{
                    textAlign: "center",
                    paddingTop: "3em",
                }}
            >
                <div
                    style={{
                        background: "white",
                        width: "fit-content",
                        display: "inline-block",
                        padding: "2em",
                    }}
                >
                    <Spinner
                        style={{
                            height: 100,
                            width: 100,
                            background: "white",
                        }}
                        color="primary"
                    />
                    <Typography
                        style={{
                            textAlign: "center",
                            marginTop: 15,
                            color: "rgba(0, 0, 0, 0.87)",
                            fontWeight: "bolder",
                            fontSize: 20,
                        }}
                        variant="subtitle1"
                    >
                        Processing...
                    </Typography>
                </div>
            </div>
        </ModalBody>
    </Modal> */}
       </>
    );
};

const validateString = (string) => {
    if (
        !string.includes("/") &&
        !string.includes("|") &&
        !string.includes("\\")
    )
        return true;
};
export default connect(
    (store) => {
        return {
            equipmentTypes: selectAllEquipmentTypes(store),
        };
    },
    { getEquipmentTypes, setActivity }
)(AddEditModal);
//export default AddEditModal;
